<template>
  <table class="w-100 bcl-token-list-table">
    <thead>
      <tr>
        <th><!-- Fake column that fixes ::before problem on rows --></th>
        <th class="text-body-2 opacity-50 text-left py-1">
          <AppTooltip>
            <template #activator>
              {{ $t("common.rank") }}
            </template>
            {{ $t("common.rankInfo") }}
          </AppTooltip>
        </th>
        <th class="text-body-2 opacity-50 text-left py-1 px-3">
          <div v-text="$t('common.tokenName')" />
        </th>
        <th class="text-body-2 opacity-50 text-left text-md-right py-1 px-3">
          <AppTooltip end>
            <template #activator>
              {{ $t("common.collection") }}
            </template>
            Category of the token.
          </AppTooltip>
        </th>
        <th class="text-body-2 opacity-50 text-left text-md-right py-1 px-3">
          {{ $t("common.price") }}
        </th>
        <th class="text-body-2 opacity-50 text-right py-1 px-3">
          {{ $t("common.marketCap") }}
        </th>
        <th class="text-body-2 opacity-50 text-right py-1 px-3">
          {{ $t("common.contractAddress") }}
        </th>
        <th class="text-body-2 opacity-50 text-right py-1 pl-3">
          {{ $t("common.performance") }}
        </th>
        <th><!-- Links placeholder column --></th>
      </tr>
    </thead>
    <tbody v-if="pages?.length">
      <TokenListTableRow
        v-for="(token, index) in allItems"
        :key="index"
        :token="token"
      />
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";

import TokenListTableRow from "./TokenListTableRow.vue";
import AppTooltip from "@/components/Common/AppTooltip.vue";

const props = defineProps({
  pages: { type: Array, default: null },
});

const allItems = computed(() =>
  props.pages?.length ? props.pages.map((page) => page.items).flat() : []
);
</script>

<style lang="scss">
.bcl-token-list-table {
  border-collapse: separate;
  border-spacing: 0 8px;

  th {
    font-weight: bold;
  }

  @media screen and (max-width: 960px) {
    thead {
      display: none;
    }
  }
}
</style>
